const theme = {
  breakpoints: [ "480px", "768px", "1024px", "1280px" ],
}

export default theme